<template>
  <p>DeleteScopeModal</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>